const ITEMS = [
  'FREE FOREVER', 'UAE FOOTBALL', 'NO WHATSAPP CHAOS',
  'ORGANIZE IN 30 SECONDS', 'YOUR SQUAD YOUR STANDARDS',
  'STREET TO STADIUM', 'EXPAT COMMUNITY', 'ZERO HIDDEN FEES',
  'BUILT IN DUBAI', 'REAL COMMUNITY',
];

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];

  return (
    <div style={{
      overflow: 'hidden',
      borderTop:    '1px solid rgba(232,96,74,0.2)',
      borderBottom: '1px solid rgba(232,96,74,0.2)',
      background: 'rgba(232,96,74,0.06)',
      padding: '12px 0',
    }}>
      <div style={{
        display: 'flex', gap: '3rem',
        width: 'max-content',
        animation: 'ticker 30s linear infinite',
      }}>
        {doubled.map((text, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '1rem', whiteSpace: 'nowrap' }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--coral)', flexShrink: 0 }} />
            <span style={{
              fontFamily: 'var(--font-d)', fontSize: 13, fontWeight: 700,
              letterSpacing: 3, color: 'var(--coral)', textTransform: 'uppercase',
            }}>{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
